// =============================================================================
// Fase 5.5 — Step 4: Veicolo da assicurare (targa + tipo)
// Skippato per tipo_richiesta = "contatto"
// =============================================================================
import React from "react";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";

export function Step4Veicolo({ state, setField }) {
  return (
    <div className="space-y-4" data-testid="rca-step4">
      <div>
        <h2 className="text-lg sm:text-xl font-semibold text-[#0F1F14]">
          Il veicolo da assicurare
        </h2>
        <p className="text-sm text-[#4A5E51] mt-1">
          Dati essenziali del veicolo. Se non ricordi la targa, chiedila all'agenzia.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 bg-white border border-[#E5E2DB] rounded-2xl p-4">
        <div>
          <Label className="text-xs">Targa *</Label>
          <Input
            value={state.veicolo.targa}
            onChange={(e) =>
              setField("veicolo.targa", e.target.value.toUpperCase().replace(/\s/g, ""))
            }
            maxLength={10}
            placeholder="AA123BB"
            data-testid="rca-veicolo-targa"
          />
        </div>
        <div>
          <Label className="text-xs">Tipo veicolo *</Label>
          <Select
            value={state.veicolo.tipo_veicolo}
            onValueChange={(v) => setField("veicolo.tipo_veicolo", v)}
          >
            <SelectTrigger className="h-10 text-sm" data-testid="rca-veicolo-tipo">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="auto">Auto</SelectItem>
              <SelectItem value="moto">Moto</SelectItem>
              <SelectItem value="autocarro">Autocarro</SelectItem>
              <SelectItem value="altro">Altro</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
}
